
















// https://nightcatsama.github.io/vue-slider-component/#/zh-CN/
import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
// @ts-ignore
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min.js'
import 'vue-slider-component/dist-css/vue-slider-component.css'
import 'vue-slider-component/theme/default.css'

export default defineComponent({
  components: {
    VueSlider,
  },
  props: {
    value: {
      type: Array as unknown as PropType<[number, number]>,
      default: () => [0, 100],
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10000,
    },
    interval: {
      type: Number,
      default: 100,
    },
  },
  setup (props, { emit }) {
    const proxyValue = computed({
      get: () => {
        const range = props.value
        const start = (range[0] === 0) ? props.min : range[0]
        const end = (range[1] === Infinity) ? props.max : range[1]
        return [start, end]
      },
      set: (range) => {
        const start = (range[0] === props.min) ? 0 : range[0]
        const end = (range[1] === props.max) ? Infinity : range[1]
        emit('input', [start, end])
      },
    })

    return {
      proxyValue,
    }
  },
})
